import { Interval, afterDay } from "components/utils/comm";
import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  useRef,
} from "react";

export type initialFilterStateProps = {
  lodChlCd: string;
  rmNo: string;
  rmOpNm: string;
  opRgSeq: number | undefined;
  sellSDt: string;
  sellEDt: string;
};
interface ProductHistoryFilterContextType {
  filters: initialFilterStateProps;
  onChange: (name: string, value: string) => void;
  onSelect: (name: string, value: string) => void;
  onPickDate: (dates: Array<string>) => void;
  onReset: () => void;
}

const ProductHistoryFilterContext = createContext<
  ProductHistoryFilterContextType | undefined
>(undefined);

interface ProductHistoryFilterProviderProps {
  children: ReactNode;
}

export const ProductHistoryFilterProvider = ({
  children,
}: ProductHistoryFilterProviderProps) => {
  const { sDt, eDt } = afterDay(Interval);
  const initialFilterState = {
    lodChlCd: "",
    rmNo: "",
    rmOpNm: "",
    opRgSeq: 1,
    sellSDt: sDt,
    sellEDt: eDt,
  };

  const [filters, setFilters] =
    useState<initialFilterStateProps>(initialFilterState);

  const onChange = (name: string, value: string) => {
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const onSelect = (name: string, value: string) => {
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const onPickDate = (dates: Array<string>) => {
    setFilters({
      ...filters,
      sellSDt: dates[0],
      sellEDt: dates[1],
    });
  };

  const onReset = () => {
    setFilters(initialFilterState);
  };

  return (
    <ProductHistoryFilterContext.Provider
      value={{
        filters,
        onChange,
        onSelect,
        onPickDate,
        onReset,
      }}
    >
      {children}
    </ProductHistoryFilterContext.Provider>
  );
};

export const useProductHistoryFilterContext =
  (): ProductHistoryFilterContextType => {
    const context = useContext(ProductHistoryFilterContext);

    if (!context) {
      throw new Error(
        "useProductHistoryFilterContext는 ProductHistoryFilterProvider 내부에서만 사용해야 합니다."
      );
    }

    return context;
  };

// Params Context
interface ProductHistoryParamsContextType {
  param: initialFilterStateProps | undefined;
  setParam: React.Dispatch<
    React.SetStateAction<initialFilterStateProps | undefined>
  >;
}

const ProductHistoryParamsContext = createContext<
  ProductHistoryParamsContextType | undefined
>(undefined);

interface ProductHistoryParamsProviderProps {
  children: ReactNode;
}

export const ProductHistoryParamsProvider = ({
  children,
}: ProductHistoryParamsProviderProps) => {
  const [param, setParam] = useState<initialFilterStateProps>();

  return (
    <ProductHistoryParamsContext.Provider
      value={{
        param,
        setParam,
      }}
    >
      {children}
    </ProductHistoryParamsContext.Provider>
  );
};

export const useProductHistoryParamsContext =
  (): ProductHistoryParamsContextType => {
    const context = useContext(ProductHistoryParamsContext);

    if (!context) {
      throw new Error(
        "useProductHistoryParamsContext는 ProductHistoryParamsProvider 내부에서만 사용해야 합니다."
      );
    }

    return context;
  };
